import { useMutation } from '@tanstack/react-query';
import { UserCredential } from 'firebase/auth';
import { signInWithToken } from 'integrations/firebase/firebase';
import { verifyOtp } from 'networking/mindfeed/services/auth.service';
type Variables = {
  email: string;
  code: string;
};

const useVerifyOtp = () => {
  return useMutation<UserCredential, Error, Variables>({
    mutationFn: async (variables) => {
      const { token } = await verifyOtp(variables);
      return signInWithToken(token);
    },
  });
};

export default useVerifyOtp;
